module.exports = __webpack_public_path__ + "img/like-active.cc3db986.svg";